import { Link } from "react-router-dom";
import { Logo } from "../Assets";
import React from "react";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer className="mt-auto w-full p-4 bg-primary sm:p-6">
      <hr className="my-4 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      <div className="flex flex-col items-center justify-center gap-2 md:flex-row md:gap-8">
        <div className="flex items-center justify-center md:justify-start">
          <div className="mb-3 md:mb-0">
            <Link to="/" className="flex items-center gap-8">
              <motion.img
                src={Logo}
                className="object-contain w-24"
                alt="Logo"
              />
            </Link>
          </div>
        </div>
        <div>
          <span className="text-sm font-semibold text-center">
            © {new Date().getFullYear()} Công ty TNHH MTV thực phẩm Giai Giai
            Việt Nam
          </span>
          <p className="text-sm">
            <span className="font-medium">Địa chỉ:</span> Tổ dân Tân Thịnh - Thị
            Trấn Tà Lùng - Huyện Quảng Hòa - Tỉnh Cao Bằng
          </p>
          <p className="text-sm">
            <span className="font-medium">SĐT:</span>{" "}
            <a href="tel:02063824058">0206 3 824 058</a> -{" "}
            <a href="tel:0369980580">0369 980 580</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
